module.exports = __webpack_public_path__ + "777d1cefb680a256afbdfb116d4b4b64.png";